import back from './icons/back.svg';
import user from './icons/user.svg';
import more from './icons/more.svg';
import image from './icons/image.svg';
import video from './icons/video.svg';
import file from './icons/file.svg';
import smile from './icons/smile.svg';
import send from './icons/send.svg';
const icons = { back, user, more, image, video, file, smile, send };
export default function ChatIcon({ name }) {
  return <img className="travel-chat-icon" src={icons[name]} width="20" height="20" alt="" aria-hidden="true" />;
}
